import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { isNotNullOrUndefined } from 'ngx-core-services';
import { Store, select } from '@ngrx/store';
import { map, withLatestFrom } from 'rxjs/operators';

import { AppState } from '..';
import { requestToAddASystem, addSystem, changeTemporarySystemState, systemSelection } from '../actions/system.actions';
import { selectTemporarySystemState, selectTemporarySystemStateAndSelectedSystemUid } from '../selectors/system.selectors';

@Injectable()
export class SystemLifeEffects {
  constructor(private actions$: Actions, private store: Store<AppState>) {}

  addSystem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(requestToAddASystem),
      withLatestFrom(this.store.pipe(select(selectTemporarySystemState))),
      map(([{ systemId, withAutomaticSelection, withAutomaticSubscription, system }, temporarySystemState]) => {
        if (
          temporarySystemState?.[systemId] === 'inProgress' ||
          temporarySystemState?.[systemId] === undefined
        ) {
          const state = 'success';
          this.store.dispatch(changeTemporarySystemState({ systemId, withAutomaticSelection, state }));
          return addSystem({ systemId, system, withAutomaticSubscription });
        }

        return null;
      }),
      isNotNullOrUndefined(),
    )
  );

  addSuccessSystem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(changeTemporarySystemState, requestToAddASystem),
      withLatestFrom(this.store.pipe(select(selectTemporarySystemStateAndSelectedSystemUid))),
      map(([{ systemId, withAutomaticSelection }, { temporarySystemState, selectedSystemUid }]) => {
        const successState = 'success';

        if (
          withAutomaticSelection &&
          temporarySystemState?.[systemId] === successState &&
          selectedSystemUid !== systemId
        ) {
          return systemSelection({ systemId });
        }

        return null;
      }),
      isNotNullOrUndefined(),
    )
  );
}
